export const educationConst = [
    {
        key: "Associate Degree",
        value: "associate_degree",   
    },

    {
        key: "Bachelors Degree",
        value: "bachelors_degree",
    },
    {
        key: "Doctoral Degree",
        value: "doctoral_degree",
    },
    {
        key: "Joint Degrees",
        value: "joint_degrees",
    },
    {
        key: "Masters Degree",
        value: "masters_degree",
    },
    {
        key: "Professional Degree",
        value: "professional_degree",
    },
    {
        key: "Professional Diploma",
        value: "professional_diploma",
    },
    {
        key: "Technical Diploma",
        value: "technical_diploma",
    },
    {
        key: "Vocational Degree",
        value: "vocational_degree",
    },
    {
        key: "Senior Secondary",
        value: "senior_secondary",
    },
    {
        key: "Higher Secondary",
        value: "higher_secondary",
    },
];
